import { useMemo } from 'react';
import { matchPath, useLocation, useRouteMatch } from 'react-router-dom';
import descriptions from './descriptions.json';
import { AppTester, AppTesterType } from 'supporting';

interface TitleDescription {
  title: string;
  description: string;
}

export const getMetaDescription = (AppTester: AppTesterType, pathname: string) => {
  const isAwardsPage = !!matchPath(pathname, { path: '/awards', exact: true });
  const isLab = !!matchPath(pathname, { path: '/laboratories', exact: true });

  if (AppTester.isHseAnimation()) {
    return descriptions.hseAnimation
  }   
  if (AppTester.isGalllleryArt()) {
    return descriptions.galllleryArt;
  }
  if (AppTester.isBooksGallllery()) {
    return descriptions.galllleryCom;
  }
  if (AppTester.isAcademy()) {
    return descriptions.creativeCity;
  }
  if (AppTester.isCGRAVE()) {
    return descriptions.cgraveRu;
  }
  if (AppTester.isGameDeziiign()) {
    return descriptions.gameDeziiignRu;
  }
  if (AppTester.isFashionDeziiign()) {
    return descriptions.fashionDeziiignRu;
  }
  if (AppTester.isBooksDeziiign()) {
    return descriptions.booksDeziiignRu;
  }
  if (AppTester.isPortfolio365()) {
    return descriptions.portfolio365;
  }
  if (AppTester.isDvaDesign()) {
    return descriptions.dvaDesign;
  }
  if (AppTester.isGreenAward()) {
    return descriptions.greenAwardRu;
  }
  if (AppTester.isMediiia()) {
    return descriptions.mediiiiaRu;
  }
  if (AppTester.isAgeytomesh()) {
    return descriptions.ageytomeshCom;
  }
  if (AppTester.isContinuumSite()) {
    return descriptions.continuumSite;
  }
  if (AppTester.isGeoDafes()) {
    return descriptions.dafesNet;
  }
  if (AppTester.isMediiiaUrban()) {
    return descriptions.mediiiiaRu;
  }
  if (AppTester.isStartHSE()) {
    return descriptions.startHse;
  }
  if (AppTester.isKiiidsArt()) {
    return descriptions.kiiidsArt;
  }
  if (AppTester.isBrnd()) {
    return descriptions.brnd;
  }
  if (AppTester.isDaMuseum()) {
    return descriptions.daMuseum;
  }
  if (AppTester.isGeograffee()) {
    return descriptions.geograffee;
  }
  if (AppTester.isSuperPuper()) {
    return descriptions.superPuper;
  }
  if (AppTester.isOnlines()) {
    return descriptions.onlines;
  }
  if (AppTester.isSchool()) {
    return descriptions.school;
  }
  if (AppTester.isAdcrDafesNet()) {
    return descriptions.adcr;
  }
  if (AppTester.isCreativeHSE()) {
    return descriptions.creativeHse;
  }
  if (AppTester.isLPUDesign()) {
    return descriptions.lpuDesign;
  }
  if (AppTester.isLMSHSE()) {
    return descriptions.lmsHsedesignRu;
  }
  if (AppTester.isHseSpace()) {
    return descriptions.hseSpace;
  }
  if (AppTester.isHSEDesign()) {
    if (isLab) {
      return descriptions.hsedesignRuLabs;
    }
    return isAwardsPage ? descriptions.hsedesignRuAwards : descriptions.hsedesignRu;
  }
  if (AppTester.isMonaLisaTravels()) {
    return descriptions.monalisatravels;
  }
  if (AppTester.isCompetition() || (AppTester.isDeziiign() && isAwardsPage)) {
    return descriptions.deziiignComAwards;
  }
  if (AppTester.isDeziiign()) {
    return descriptions.deziiignCom;
  }
  return null;
}

const useMetaDescription = () => {
  const isProjectPage = !!useRouteMatch('/project');
  const isDesignerPage = !!useRouteMatch('/designer');
  const isTeamPage = !!useRouteMatch('/teams/:id') && !AppTester.isLMSHSE();
  const isAwardsPage = !!useRouteMatch('/awards');
  const isCompetitionPage = !!useRouteMatch('/competition/:id');
  const isLab = !!useRouteMatch('/laboratories');
  const { pathname } = useLocation();

  const meta = useMemo(() => {

    return getMetaDescription(AppTester, pathname);
  }, [isAwardsPage, isLab]);

  if (!meta) {
    return null;
  }

  const shouldDisplayMeta = !isProjectPage && !isDesignerPage && !isTeamPage;
  const domain = window.location.origin;
  const currentUrl = window.location.href;

  const onlyDescription = isCompetitionPage;

  const descriptionTags = !!meta.description?.length ? [
    <meta name="description" content={meta.description} />,
    <meta property="og:description" content={meta.description} />,
    <meta name="twitter:description" content={meta.description} />,
  ] : [];

  if (onlyDescription) {
    return descriptionTags;
  }

  return shouldDisplayMeta && [
    <title>{meta.title}</title>,
    <meta name="title" content={meta.title} />,
    <meta property="og:site_name" content={domain} />,
    <meta property="og:url" content={currentUrl} />,
    <meta property="og:type" content="website" />,
    <meta property="og:title" content={meta.title} />,
    <meta property="twitter:domain" content={domain} />,
    <meta property="twitter:url" content={currentUrl} />,
    <meta name="twitter:title" content={meta.title} />,
    ...descriptionTags,
  ];
};

export default useMetaDescription;
import { useMemo } from 'react';
import { matchPath, useLocation, useRouteMatch } from 'react-router-dom';
import descriptions from './descriptions.json';
import { AppTester, AppTesterType } from 'supporting';

interface TitleDescription {
  title: string;
  description: string;
}

export const getMetaDescription = (AppTester: AppTesterType, pathname: string) => {
  const isAwardsPage = !!matchPath(pathname, { path: '/awards', exact: true });
  const isLab = !!matchPath(pathname, { path: '/laboratories', exact: true });

  if (AppTester.isHseAnimation()) {
    return descriptions.hseAnimation
  }   
  if (AppTester.isGalllleryArt()) {
    return descriptions.galllleryArt;
  }
  if (AppTester.isBooksGallllery()) {
    return descriptions.galllleryCom;
  }
  if (AppTester.isAcademy()) {
    return descriptions.creativeCity;
  }
  if (AppTester.isCGRAVE()) {
    return descriptions.cgraveRu;
  }
  if (AppTester.isGameDeziiign()) {
    return descriptions.gameDeziiignRu;
  }
  if (AppTester.isFashionDeziiign()) {
    return descriptions.fashionDeziiignRu;
  }
  if (AppTester.isBooksDeziiign()) {
    return descriptions.booksDeziiignRu;
  }
  if (AppTester.isPortfolio365()) {
    return descriptions.portfolio365;
  }
  if (AppTester.isDvaDesign()) {
    return descriptions.dvaDesign;
  }
  if (AppTester.isGreenAward()) {
    return descriptions.greenAwardRu;
  }
  if (AppTester.isMediiia()) {
    return descriptions.mediiiiaRu;
  }
  if (AppTester.isAgeytomesh()) {
    return descriptions.ageytomeshCom;
  }
  if (AppTester.isContinuumSite()) {
    return descriptions.continuumSite;
  }
  if (AppTester.isGeoDafes()) {
    return descriptions.dafesNet;
  }
  if (AppTester.isMediiiaUrban()) {
    return descriptions.mediiiiaRu;
  }
  if (AppTester.isStartHSE()) {
    return descriptions.startHse;
  }
  if (AppTester.isKiiidsArt()) {
    return descriptions.kiiidsArt;
  }
  if (AppTester.isBrnd()) {
    return descriptions.brnd;
  }
  if (AppTester.isDaMuseum()) {
    return descriptions.daMuseum;
  }
  if (AppTester.isGeograffee()) {
    return descriptions.geograffee;
  }
  if (AppTester.isSuperPuper()) {
    return descriptions.superPuper;
  }
  if (AppTester.isOnlines()) {
    return descriptions.onlines;
  }
  if (AppTester.isSchool()) {
    return descriptions.school;
  }
  if (AppTester.isAdcrDafesNet()) {
    return descriptions.adcr;
  }
  if (AppTester.isCreativeHSE()) {
    return descriptions.creativeHse;
  }
  if (AppTester.isLPUDesign()) {
    return descriptions.lpuDesign;
  }
  if (AppTester.isLMSHSE()) {
    return descriptions.lmsHsedesignRu;
  }
  if (AppTester.isHseSpace()) {
    return descriptions.hseSpace;
  }
  if (AppTester.isHSEDesign()) {
    if (isLab) {
      return descriptions.hsedesignRuLabs;
    }
    return isAwardsPage ? descriptions.hsedesignRuAwards : descriptions.hsedesignRu;
  }
  if (AppTester.isMonaLisaTravels()) {
    return descriptions.monalisatravels;
  }
  if (AppTester.isCompetition() || (AppTester.isDeziiign() && isAwardsPage)) {
    return descriptions.deziiignComAwards;
  }
  if (AppTester.isDeziiign()) {
    return descriptions.deziiignCom;
  }
  return null;
}

const useMetaDescription = () => {
  const isProjectPage = !!useRouteMatch('/project');
  const isDesignerPage = !!useRouteMatch('/designer');
  const isTeamPage = !!useRouteMatch('/teams/:id') && !AppTester.isLMSHSE();
  const isAwardsPage = !!useRouteMatch('/awards');
  const isCompetitionPage = !!useRouteMatch('/competition/:id');
  const isLab = !!useRouteMatch('/laboratories');
  const { pathname } = useLocation();

  const meta = useMemo(() => {

    return getMetaDescription(AppTester, pathname);
  }, [isAwardsPage, isLab]);

  if (!meta) {
    return null;
  }

  const shouldDisplayMeta = !isProjectPage && !isDesignerPage && !isTeamPage;
  const domain = window.location.origin;
  const currentUrl = window.location.href;

  const onlyDescription = isCompetitionPage;

  const descriptionTags = !!meta.description?.length ? [
    <meta name="description" content={meta.description} />,
    <meta property="og:description" content={meta.description} />,
    <meta name="twitter:description" content={meta.description} />,
  ] : [];

  if (onlyDescription) {
    return descriptionTags;
  }

  return shouldDisplayMeta && [
    <title>{meta.title}</title>,
    <meta name="title" content={meta.title} />,
    <meta property="og:site_name" content={domain} />,
    <meta property="og:url" content={currentUrl} />,
    <meta property="og:type" content="website" />,
    <meta property="og:title" content={meta.title} />,
    <meta property="twitter:domain" content={domain} />,
    <meta property="twitter:url" content={currentUrl} />,
    <meta name="twitter:title" content={meta.title} />,
    ...descriptionTags,
  ];
};

export default useMetaDescription;
